import ApiService from "@/common/api.service";

const state = {
  loadedLocation: null,
  loadingLocation: false,
  selectedLocation: { id: 1, name: "Location 1"},
};

const getters = {
  loadedLocation(state) {
    return state.loadedLocation;
  },
  loadingLocation(state) {
    return state.loadingLocation;
  },
  selectedLocation(state) {
    return state.selectedLocation;
  },
}

const actions = {
  getLocation(context, body) {
    context.commit('setLoadingLocation', true);
    return new Promise((resolve, reject) => {
      ApiService.get("/commercial/location", body)
        .then(response => {
          context.commit('setLocation', response.data.commercial_locations);
          context.commit('setLoadingLocation', false);
          resolve(response.data.commercial_locations);
        })
        .catch(({response}) => {
          context.commit('setLoadingLocation', false);
          reject(response);
        })
    })
  }
}

const mutations = {
  setLocation(state, location) {
    state.loadedLocation = location;
  },
  setLoadingLocation(state, status) {
    state.loadingLocation = status;
  },
  setSelectedLocation(state, location) {
    state.selectedLocation = location;
  },
};

export default {
  state,
  actions,
  mutations,
  getters
};